export default "__VITE_ASSET__D9E3caA9__"